import DocumentsQuery from "./documents-query";
import { arrayRemove } from "../utils";
import IFilterResult from "../interface/filter-result";
import IDocument from "../interface/document";
import Global from "../global";

const DocumentsCacheExpiration = Global.DOCUMENT_CACHE_EXPIRATION;

export default class DocumentsCacheItem {

    public entityId: number | undefined;

    public query: DocumentsQuery;

    private documents: IDocument[] = [];

    private timestamp: number = 0;

    constructor(entityId: number, documents: IDocument[], query: DocumentsQuery | null = null) {
        this.entityId = entityId;
        this.documents = documents;
        if (query === null) {
            this.query = new DocumentsQuery({});
        } else {
            this.query = query;
        }
        this.setTimestamp();
    }

    public clear(): void {
        this.entityId = undefined;
        this.documents = [];
    }

    public expired(): boolean {
        const timestamp: number = (new Date()).getTime();
        return timestamp - this.timestamp > DocumentsCacheExpiration;
    }

    public getData(): IDocument[] {
        this.setTimestamp();
        return this.documents;
    }

    public documentsCreate(documents: IDocument[]): void {
        const filterResult: IFilterResult = this.query.testDocuments(documents);
        documents = documents.filter((doc: IDocument) => filterResult[doc.id as number]);
        if (documents.length) {
            this.documents = this.documents.concat(documents);
            this.setTimestamp();
        }
    }

    public documentsUpdate(documents: IDocument[]): void {
        const ids = this.documents.map((doc: IDocument) => doc.id);
        const filterResult: IFilterResult = this.query.testDocuments(documents);
        let toCreate: IDocument[] = [];
        let toUpdate: IDocument[] = [];
        let toDelete: IDocument[] = [];
        documents.forEach((doc: IDocument) => {
            const index = ids.indexOf(doc.id);
            if (index > -1) {
                if (filterResult[doc.id as number]) {
                    this.documents[index] = doc;
                    toUpdate.push(doc);
                } else {
                    const toDelete: IDocument | undefined = this.documents.find((d: IDocument) => d.id === doc.id);
                    arrayRemove(this.documents, toDelete);
                    toCreate.push(doc);
                }
            } else {
                if (filterResult[doc.id as number]) {
                    this.documents.push(doc);
                    toCreate.push(doc);
                }
            }
        });
        if (toCreate.length || toUpdate.length || toDelete.length) {
            this.setTimestamp();
        }
    }

    public documentsDelete(documents: IDocument[]): void {
        const toDelete: IDocument[] = [];
        const documentsIds = documents.map(record => record.id);
        this.documents.forEach(doc => {
            if (documentsIds.indexOf(doc.id) > -1) {
                toDelete.push(doc);
            }
        });
        if (toDelete.length) {
            toDelete.forEach((doc: IDocument) => arrayRemove(this.documents, doc));
            this.setTimestamp();
        }
    }

    private setTimestamp(): void {
        this.timestamp = (new Date()).getTime();
    }

}

